import { useContext, useEffect } from "react";

import { useNavigate, useParams } from "react-router-dom";

import { useAuth } from "../hooks/useAuth";
import { ToastContext } from "../Components/ToastProvider";

function ConfirmingEmail(id) {
    const { token } = useParams();

    const { confirmEmail } = useAuth();

    const { createToast } = useContext(ToastContext);

    const navigate = useNavigate();

    useEffect(() => {
        confirmEmail(token).then(
            async (success) => {
              if (success) {
                createToast("You have confirmed your email address.  Now you can log in.", "success");
                navigate("/login");
              } else {
                createToast("Please try again.", "error");
              }
            }
        );      

    }, [confirmEmail, createToast, navigate, token]);

  return (
    <div>
      <h1>Thanks for confirming your email.</h1>
      <p>You will now be redirected to login.</p>
    </div>
  );
}

export default ConfirmingEmail;
